// @flow
import uuid from 'uuid';
import type { Pet } from '@rover/react-lib/types';

export const PET_DEFAULTS: $Diff<Pet, { id: $PropertyType<Pet, 'id'> }> = {
  pk: '',
  url: '',
  name: '',
  weight: '',
  breeds: [],
  ageYears: '',
  ageMonths: '',
  gender: '',
  isPuppy: false,
  defaultImage: {
    bigThumb: 'https://www.rover.com/static/images/profilable/defaults/big_thumb.png',
  },
  petType: 'dog',
  weightObj: [],
  owner: '',
  webUrl: '',
  urls: { images: '' },
  active: true,
  dogSize: '',
  careInstructions: '',
  veterinaryInformation: '',
  emergencyContactInformation: '',
  birthday: '',
  birthdayDisplay: '',
  implant: null,
  spayedNeutered: null,
  description: null,
  specialRequirements: null,
  houseTrained: null,
  houseTrainedDesc: null,
  playsChildren: null,
  playsChildrenDesc: null,
  playsDogs: null,
  playsDogsDesc: null,
  playsCats: null,
  playsCatsDesc: null,
  notes: null,
  petDetails: [],
};

export default (opts: $Shape<Pet> = {}): Pet => ({
  ...PET_DEFAULTS,
  id: uuid.v4(),
  ...opts,
});



// WEBPACK FOOTER //
// ../react-lib/src/factories/petFactory.js